module.exports = __webpack_public_path__ + "static/media/basic_booster.2cd74510.webp";